import { Form, Input } from 'antd';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { MarkdownDescription } from 'app/components/commons/MarkdownDescription/MarkdownDescription';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';

export const ImportantInformation = () => {
  const { isEditMode } = useContext(ViewEditModeContext);
  const form = Form.useFormInstance();
  const importantInformationValue = Form.useWatch('importantInformation', form);

  return (
    <FormLineLayout
      label={<MarkdownDescription label="Important information" />}
      labelOnTop
      rightClassName="copywriting-form"
    >
      <Form.Item name="importantInformation">
        {isEditMode ? (
          <Input.TextArea rows={2} />
        ) : (
          <span className="view-data">
            {importantInformationValue ? importantInformationValue : 'ø empty'}
          </span>
        )}
      </Form.Item>
    </FormLineLayout>
  );
};
